var TWEEN = require('@tweenjs/tween.js');

/*
* Count plugin
*/

$.fn.Count = function()
{
  var self = this;
  self.hasRun = false;
  self.hasEnded = false;
  self.tween = undefined;
  self.current = 0;
  self.total = 0;
  self.delay = parseInt(self.data('count-delay'), 0);

  self.tick = function(time)
  {
    self.tween.update(time);
    if (!self.hasEnded){
      requestAnimationFrame(self.tick);
    }
  };

  self.run = function()
  {
    // only run once
    if (self.hasRun) return;
    self.hasRun = true;
    let locale = $('html').attr('lang') == 'en' ? 'en-CA' : 'fr-CA';

    // run tween
    self.text('1');
    self.tween = new TWEEN.Tween(self)
      .to({current: self.total}, 1500 + self.delay)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate(function(){
        self.text(Math.round(self.current).toLocaleString(locale));
      })
      .onComplete(function(){
        self.hasEnded = true;
        self.css('width', '');
      })
      .start();
    requestAnimationFrame(self.tick);
  };

  return function()
  {
    if (isNaN(self.delay)) self.delay = 0;
    self.total = parseInt(self.text().replace(/ /g, ''), 10);
    self.width(self.width());
    self.text('0');
    self.addClass('count--ready');
    return self;
  }();
};
